import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { getSearchValueByKey } from "../../../../Redux/Selectors/searchSelectors";
import DateInput from "../../../ShopPage/forms/AddPeopleForm/CalendarInput/DateInput";
import { useTranslation } from "react-i18next";
import Paragraph from "antd/es/typography/Paragraph";
import useIsMobile from "../../../../hooks/useIsMobile";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  background-color: white;
  margin-top: 10px;
`;
const Wrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.borders.gray};
  padding-left: 25px;
  padding-right: 25px;
  border-radius: ${({ isMobile }) => (isMobile ? "0px" : "10px")};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  height: 50px;
`;

const DatesInput = ({ handleShowModal, bodyStyle }) => {
  const { t } = useTranslation("shop");
  const isMobile = useIsMobile();
  const dates = useSelector((state) => getSearchValueByKey(state, "dates"));
  const { from, to } = dates;
  return (
    <div>
      <Container
        onClick={() => handleShowModal("calendar")}
        style={{ ...bodyStyle }}
      >
        <Wrapper
          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
        >
          <DateInput label={t("startDate")} value={from} align="left" />
        </Wrapper>
        <Wrapper
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          isMobile={isMobile}
        >
          <DateInput label={t("dropOffDate")} value={to} align="left" />
        </Wrapper>
      </Container>
      <Paragraph
        type="secondary"
        style={{ fontSize: 12, marginTop: 10, marginBottom: 0 }}
      >
        Las fechas que seleccionas pueden afectar los precios.
      </Paragraph>
    </div>
  );
};

export default DatesInput;
